import { createAction, props } from '@ngrx/store';
import { InhLanguage } from 'src/app/shared/constants-and-enums/language';

export enum LanguageActionTypes {
    ChangeLanguage = '[User] Change Language'
}

export const ChangeLanguage = createAction(LanguageActionTypes.ChangeLanguage, props<{ language: InhLanguage }>());
